import { schema } from "normalizr";
import { AvailabilitySchema } from "./availability";

export const AvailabilitiesSchema = new schema.Array(AvailabilitySchema);
